import { Box, List } from '@mui/material'

import { Spinner } from 'packages/eid-ui'
import CheckBoxListItem from './CheckBoxListItem'

export default function CheckboxListWithInfoIcon(props) {
    const {
        handleToggle,
        checked,
        loading,
        dataList,
        highlightText,
        fallbackMessage,
        highlightSelected = false,
        showInfoTooltip = false,
    } = props

    return loading ? (
        <Box
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            padding="2rem"
            marginLeft="-1rem"
        >
            <Spinner />
        </Box>
    ) : (
        dataList && (
            <List
                sx={{
                    width: '100%',
                }}
            >
                {dataList.length === 0 && <>{fallbackMessage}</>}
                {dataList.map((item, index) => {
                    const labelId = `checkbox-list-label-${item.friendlyName}`

                    return (
                        <CheckBoxListItem
                            key={`checkbox-list-label-${index}`}
                            highlightText={highlightText}
                            highlightSelected={highlightSelected}
                            labelId={labelId}
                            handleToggle={handleToggle}
                            checked={checked}
                            item={item}
                            showInfoTooltip={showInfoTooltip}
                        />
                    )
                })}
            </List>
        )
    )
}
